module.exports = "<!--\r\nAdd your custom code here.\r\nThis file and any changes you make to it are preserved every time the app is generated.\r\n-->"


//////////////////
// WEBPACK FOOTER
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/modules/application/unauthorized-page/topSection.html
// module id = ../../../../../src/app/modules/application/unauthorized-page/topSection.html
// module chunks = main